'use strict';

var Validator = require('validator');

// Constructor
var FormValidation = function() {

  var self = this;

  self.config = {
    'form'      :  '[data-validate]',
    'messages'  :  '[data-validate-messages]'
  }

  self.initValidation = function() {

    var form = document.querySelector(self.config.form);
    var messages = JSON.parse(form.querySelector(self.config.messages).textContent);
    var validator = new Validator(form, {
      success: function(e) {

        var input = e.target;

        if (input.parentNode.querySelector('small.error') !== null) {

          var errorMessageEl = input.parentNode.querySelector('small.error');

          input.parentNode.removeChild(errorMessageEl);
          input.parentNode.classList.remove('error');
          input.classList.remove('error');
        }
      },
      error: function(e) {

        var input = e.target;

        input.focus();
        input.parentNode.classList.add('error');
        input.classList.add('error');

        // Add error message
        if (input.parentNode.querySelector('small.error') === null) {

          var errorMessageEl = document.createElement('small');
          var message = e.detail.message;
          var minMaxValue = '';

          if (input.hasAttribute('min')) {
            minMaxValue = input.getAttribute('min');
            message = message.replace('%d', minMaxValue);
          }

          if (input.hasAttribute('max')) {
            minMaxValue = input.getAttribute('max');
            message = message.replace('%d', minMaxValue);
          }

          errorMessageEl.classList.add('error');
          errorMessageEl.textContent = message;
          input.insertAdjacentElement('afterend', errorMessageEl);
        }
      },
      messages: messages
    });

    form.querySelector('button[type="submit"]').addEventListener('click', function(e) {
      if (validator.isInvalid()) {
        e.preventDefault();
      }
    }, false);
  }

  self.init = function() {

    if (document.querySelector(self.config.form) !== null) {
      self.initValidation();
    }
  }
};

module.exports = FormValidation;
